import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  contentOne: string;
  contentTwoShow: boolean;
  contentOneShow: boolean;
  contentTwo: string;
  breadcrumbOne: string;
  breadcrumbTwo: string;
  handleInputText: (inputText: any) => void;
}
const FilterSection = (props: Props) => {
  return (
    <div className="filter-section">
      <div className="input-container-wrapper">
        {props.contentOneShow ? (
          <input
            type="text"
            className="search p2 input-control"
            placeholder={props.contentOne}
            onChange={(e) => props.handleInputText(e.target.value)}
          />
        ) : null}
        {props.contentTwoShow ? (
          <input
            type="text"
            className="search p2 input-control"
            placeholder={props.contentTwo}
          />
        ) : null}

        <FontAwesomeIcon icon={faSearch} className="fa-search" />
      </div>
    </div>
  );
};

export default FilterSection;
